import { endpoints } from 'constants/endpoints'
import type { Cliente } from 'container/CreateOrder'
import api from 'services/api'

import type { RequestBodyListClient } from './interfaces'

/**
 * @deprecated This service/type is deprecated and should not be used in new features
 * Use the new services/types from `services/shared/customers`
 */
export const getCustomers = async (query?: RequestBodyListClient) => {
  const response = await api.get<Cliente[]>(endpoints.clients, {
    params: query,
  })

  return response.data
}
